export const URL_API = "https://api.themoviedb.org/3";
export const URL_KEY = "184002f5e0fd334790546ef8db2653fa";
